module.exports = __webpack_public_path__ + "img/11.9d07d942.jpg";